import { render, staticRenderFns } from "./DishCard.vue?vue&type=template&id=396331c8&scoped=true"
import script from "./DishCard.vue?vue&type=script&lang=js"
export * from "./DishCard.vue?vue&type=script&lang=js"
import style0 from "./DishCard.vue?vue&type=style&index=0&id=396331c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396331c8",
  null
  
)

export default component.exports